<div class="p-4 bg-gray-opacity2 rounded-2xl mt-8 flex items-center justify-between flex-col">
  <img width="64px" class="rounded-full" src="./assets/icons/profile-icon.svg" />
  <div class="loading-mask" *ngIf="loading" style="margin-top: 48px; margin-bottom: 48px">
    <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
  </div>
  <div class="w-full flex flex-col" *ngIf="!loading">
    <div class="flex items-center flex-col gap-2 mt-8 mb-8">
      <h2 class="m-0 tracking-tight text-gray font-semibold">
        {{ !name ? phone_number : name }}
      </h2>
      <div class="text-gray text-base">
        {{ !name ? '' : phone_number }}
        <ng-container *ngIf="phone_number_verified; then verified else notVerified"></ng-container>
        <ng-template #verified>
          <mat-chip color="secondary">{{ 'COMPONENTS.PROFILE.MY_PROFILE.VERIFIED' | translate }}</mat-chip>
        </ng-template>
        <ng-template #notVerified>
          <mat-chip>{{ 'COMPONENTS.PROFILE.MY_PROFILE.NOT_VERIFIED' | translate }}</mat-chip>
        </ng-template>
      </div>
      <div class="text-gray text-base">
        {{ email }}
      </div>
      <div class="text-gray text-base">
        <div class="text-2xl font-bold text-green-600">€ {{ balanceAmount | number:'1.2-2' }} </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="flex flex-row mt-8 mb-8 w-full justify-evenly md:justify-center md:gap-16">
      <div *ngIf="phone_number" class="flex flex-col items-center gap-2">
        <button
          (click)="onEdit()"
          class="text-black font-bold py-2 px-4 rounded hover:bg-gray-200 transition flex items-center justify-center">
          <img src="./assets/icons/edit-profile.svg" alt="Edit Profile" />
        </button>
        <div class="text-gray text-base text-center">
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT' | translate }}
        </div>
      </div>
      <div *ngIf="phone_number" class="flex flex-col items-center gap-2">
        <button
          (click)="onBalance()"
          [disabled]="isVerificationInProgress"
          class="text-black font-bold py-2 px-4 rounded disabled:bg-gray-400 hover:bg-gray-200 transition">
          <img src="./assets/icons/user-balance-edit.svg" alt="Verify" />
        </button>
        <div class="text-gray text-base text-center">
          {{ 'BACKOFFICE.USERS.PROFILE.BALANCE_TRANSACTIONS' | translate }}
        </div>
      </div>
      <div *ngIf="phone_number" class="flex flex-col items-center gap-2">
        <button
          (click)="addBalance()"
          [disabled]="isVerificationInProgress"
          class="text-black font-bold py-2 px-4 rounded disabled:bg-gray-400 hover:bg-gray-200 transition">
          <img src="./assets/icons/recarga.png" alt="Verify" />
        </button>
        <div class="text-gray text-base text-center">
         {{ 'BACKOFFICE.USERS.PROFILE.ADD_BALANCE' | translate }}
        </div>
      </div>
      <div *ngIf="phone_number" class="flex flex-col items-center gap-2">
        <button
          (click)="addtravelsim()"
          [disabled]="isVerificationInProgress"
          class="text-black font-bold py-2 px-4 rounded disabled:bg-gray-400 hover:bg-gray-200 transition">
          <img src="./assets/icons/Esim.svg" alt="Verify" />
        </button>
        <div class="text-gray text-base text-center">
         {{ 'BACKOFFICE.USERS.PROFILE.ADD_ESIM' | translate }}
        </div>
      </div>
      <div *ngIf="phone_number" class="flex flex-col items-center gap-2">
        <button
          (click)="onViewEsims()"
          [disabled]="isVerificationInProgress"
          class="text-black font-bold py-2 px-4 rounded disabled:bg-gray-400 hover:bg-gray-200 transition">
          <img src="./assets/icons/Esim.svg" alt="View eSIMs" />
        </button>
        <div class="text-gray text-base text-center">
         {{ 'BACKOFFICE.USERS.PROFILE.VIEW_ESIMS' | translate }}
        </div>
      </div>
      <!--<div class="flex flex-col items-center gap-2">
        <button
          (click)="openVerification()"
          [disabled]="isVerificationInProgress"
          class="text-black font-bold py-2 px-4 rounded disabled:bg-gray-400 hover:bg-gray-200 transition">
          <img src="./assets/icons/my-profile-change-password.svg" alt="Verify" />
        </button>
        <div class="text-gray text-base text-center">
          Reenviar verificación
        </div>
      </div>-->
      <div *ngIf="phone_number" class="flex flex-col items-center gap-2">
        <button
          (click)="onDelete()"
          [disabled]="isVerificationInProgress"
          class="text-black font-bold py-2 px-4 rounded disabled:bg-gray-400 hover:bg-gray-200 transition">
          <img src="./assets/icons/my-profile-trash.svg" />
        </button>
        <div class="text-gray text-base text-center">
          {{ 'BACKOFFICE.USERS.PROFILE.DELETE_PROFILE' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div>
    <button mat-button color="primary" (click)="goBack()">{{ 'BACKOFFICE.USERS.PROFILE.BACK' | translate }}</button>
  </div>
</div>
